import React, { ReactElement } from 'react';
import Tippy from '@tippyjs/react/headless';
import { Square } from '@grubhubprod/gh-cookbook-react/dist';

interface ITooltipProps {
  children: ReactElement;
  content: JSX.Element;
  maxWidth?: string;
  roundedContainer?: boolean;
  disabled?: boolean;
  interactive?: boolean;
  offset?: [number, number];
}

export function Tooltip({
  children,
  content,
  maxWidth = 'auto',
  roundedContainer,
  disabled,
  interactive,
  offset,
}: ITooltipProps): JSX.Element {
  return (
    <Tippy
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(offset && { offset })}
      interactive={interactive}
      disabled={disabled}
      render={(attributes) => (
        <Square
          inset="md"
          color="invertedPrimaryText"
          backgroundColor="defaultTooltip"
          className="tooltipContainer"
          borderRadius={roundedContainer ? '4px' : '0'}
          maxWidth={maxWidth}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...attributes}
        >
          {content}
          <span data-popper-arrow className="arrow" />
        </Square>
      )}
    >
      {children}
    </Tippy>
  );
}
